import React from 'react';
import { Minus, Plus } from 'lucide-react';

export default function QuantityControl({ value, onChange, min = 1, className = '', inputClassName = '', buttonClassName = '' }) {
  const numericValue = Number(value) || min;
  const safeValue = Math.max(min, numericValue);
  const disabledMinus = safeValue <= min;

  function setNext(next) {
    const parsed = Number(next);
    onChange(Number.isFinite(parsed) ? Math.max(min, parsed) : min);
  }

  function handleInputChange(next) {
    if (next === '') {
      onChange('');
      return;
    }
    const parsed = Number(next);
    if (Number.isFinite(parsed)) onChange(parsed);
  }

  function handleInputBlur(next) {
    const parsed = Number(next);
    onChange(Number.isFinite(parsed) && parsed >= min ? parsed : min);
  }

  return (
    <div className={`inline-flex items-center overflow-hidden rounded-2xl border border-gray-200 bg-white ${className}`} dir="ltr">
      <button
        type="button"
        onClick={() => setNext(safeValue - 1)}
        disabled={disabledMinus}
        className={`m-1 flex h-8 w-8 items-center justify-center rounded-full transition ${buttonClassName} ${disabledMinus ? 'cursor-not-allowed bg-gray-100 text-gray-300' : 'text-[#005bbb] hover:bg-red-50 hover:text-red-600'}`}
        aria-label="کاهش تعداد"
      >
        <Minus className="h-4 w-4" />
      </button>
      <input
        type="number"
        min={min}
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
        onBlur={(e) => handleInputBlur(e.target.value)}
        className={`h-10 w-14 border-0 bg-transparent text-center text-sm font-bold outline-none focus:ring-0 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${inputClassName}`}
      />
      <button
        type="button"
        onClick={() => setNext(safeValue + 1)}
        className={`m-1 flex h-8 w-8 items-center justify-center rounded-full text-[#005bbb] transition hover:bg-green-50 hover:text-green-600 ${buttonClassName}`}
        aria-label="افزایش تعداد"
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
